import { getCardList } from "@/api/order";

const typeNames = {
  SET_DATA_CARD: "SET_DATA_CARD"
};

const state = {
  dataCard: {}
};

const mutations = {
  [typeNames.SET_DATA_CARD]: (state, dataCard) => {
    state.dataCard = dataCard;
  }
};

const actions = {
  getData({ commit }, code) {
    return new Promise(resolve => {
      getCardList(code)
        .then(res => {
          commit(typeNames.SET_DATA_CARD, res);
          resolve(res);
        })
        .catch(e => {
          console.log(e);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
